export interface IBottomSheetHandleProps {
  className: string;
}

/**
 * The decorative grabber pill at the top of a sheet. `useBottomSheet` renders
 * `DraggableSheetHandle` in place of this one when `swipeToDismiss` is set; every other sheet
 * gets this.
 */
export function BottomSheetHandle({ className }: IBottomSheetHandleProps) {
  return (
    <div
      className={className}
      aria-hidden="true"
      data-testid="bt-bottom-sheet-handle"
    />
  );
}
